import * as geoUtils from "@/utils/geoDistance";

const baseURL = `${process.env.VUE_APP_SERVER_URL}/FormasContato`;

export async function ObterParametrosEndereco({ vinculo }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterParametrosEndereco`,
      query: {
        vinculo
      }
    })
    .then(resp => resp.data.Data)
    .catch(error => {
      globalThis.window.$log.error("ObterParametrosEndereco", error.message);
      return error;
    });
}

export async function ObterFormasContato({ vinculo }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterFormasContato`,
      query: {
        vinculo
      }
    })
    .then(resp => resp.data.Data)
    .catch(error => {
      globalThis.window.$log.error("ObterFormasContato", error);
      return error;
    });
}

export async function SolicitarAlteracaoGeral({ vinculo, usuario, emails, endereco, telefones, autenticacao }) {
  const coords: any = await geoUtils.GetLocation().catch(() => null);
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/SolicitarAlteracaoGeral`,
      query: {
        vinculo
      },
      data: {
        usuario,
        emails,
        endereco,
        telefones,
        autenticacao,
        lat: coords?.latitude,
        lng: coords?.longitude
      }
    })
    .then(resp => resp.data.Data)
    .catch(error => {
      globalThis.window.$log.error("SolicitarAlteracaoGeral", error.message);
      return error;
    });
}

export async function ValidarAlteracaoGeral({ vinculo, emails, endereco, telefones, permitirSemAlteracao }) {
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/ValidarAlteracaoGeral`,
      query: {
        vinculo
      },
      data: {
        emails,
        endereco,
        telefones,
        permitirSemAlteracao
      }
    })
    .then(resp => resp.data.Data)
    .catch(error => {
      globalThis.window.$log.error("ValidarAlteracao", error.message);
      return error;
    });
}

export async function ConsultarRequisicaoAlteracao({ chave }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ConsultarRequisicaoAlteracao`,
      query: {
        chave
      }
    })
    .then(resp => resp.data.Data)
    .catch(error => {
      globalThis.window.$log.error("ConsultarRequisicaoAlteracao", error.message);
      return error;
    });
}

export async function ObterMunicipios({ vinculo, uf }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterMunicipios`,
      query: {
        vinculo,
        uf
      }
    })
    .then(resp => resp.data.Data)
    .catch(error => {
      globalThis.window.$log.error("ObterMunicipios", error.message);
      return error;
    });
}

export function ObterLogradouros({ vinculo, cep }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterLogradouros`,
      query: {
        vinculo,
        cep
      }
    })
    .then(resp => resp.data.Data)
    .catch(error => {
      globalThis.window.$log.error("ObterLogradouros", error.message);
      return error;
    });
}

export function ObterResumoFormasContato({ vinculo }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterResumoFormasContato`,
      query: {
        vinculo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterResumoFormasContato", error.message);
      return error;
    });
}
